import React, { FC } from 'react';
import * as S from 'components/Forms/Forms.style';

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  register: any;
  rules?: object;
  errorMessage?: string;
}

export const TextInput: FC<TextInputProps> = ({
  label,
  name,
  register,
  rules,
  errorMessage,
  ...props
}) => {
  return (
    <S.FormItem>
      <label>{label}</label>
      <S.Input {...register(name, rules)} type="text" {...props} />
      {errorMessage && <S.ErrorMessage>{errorMessage}</S.ErrorMessage>}
    </S.FormItem>
  );
};
